import {
  defaultCalculateParameters,
  getRendererFromDescriptor,
} from '@kizi/comparator-core';
import {
  faqItems,
  howWeCompareItems,
} from '../../../content/healthModalsContent';
import {
  registerAnalyticsAddToCartEvent,
  registerAnalyticsViewItemEvent,
  registerAnalyticsViewListEvent,
} from '../../../utils/analytics';
import { getCheckoutEvent, getStep3DataEvent } from '../../../utils/peregrine';
import uspMobile from '../widgets/Usp/uspMobile';

const mailMeThisOverview = (buttonLabel = 'E-mail dit overzicht') => ({
  type: 'MailMeThisOverview',
  props: {
    title: 'Op een later moment verder gaan?',
    showIcon: true,
    buttonLabel,
    buttonIcon: 'send',
    requestEndpoint: {
      url: `${process.env.KIZI_PUBLIC_GRAPH_API_BASE_URL}/comparisons/:id/sendtoemail/`,
      options: {
        method: 'POST',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${process.env.KIZI_PUBLIC_API_AUTH_TOKEN}`,
        },
      },
    },
    requestLogIdName: 'overview.requestLogId',
    innerModal: {
      inputLabel: 'E-mailadres',
      submitButton: 'Verzenden',
      text: 'Vul je e-mailadres in en wij sturen je dit overzicht. Zo kun je het later nog eens rustig bekijken voordat je een beslissing neemt.',
      textBeforePrivacyModal:
        'We gebruiken je e-mailadres voor het toesturen van dit overzicht en we zullen je nog 2 herinneringen sturen. Lees onze',
      textAfterPrivacyModal: 'voor meer informatie.',
    },
    privacyUrl: 'https://www.overstappen.nl/privacy-cookies/',
  },
});

export const usp = (uspText) => ({
  type: 'Div',
  props: {
    display: 'flex',
    alignItems: 'center',
    gridGap: 1,
  },
  _children: [
    {
      type: 'IconV2',
      props: {
        name: 'green-check',
        size: 28,
        css: {
          flexShrink: 0,
        },
      },
    },
    {
      type: 'P',
      props: {
        fontWeight: 300,
        variant: 'footnoteRegularLight',
        color: 'main.5',
        children: uspText,
        textAlign: 'start',
      },
    },
  ],
});

const personalData = {
  type: 'PersonalData2',
  props: {
    p: '16px!important',
    mb: 6,
    variant: 'primaryCard',
    fieldNames: [
      'getUserInput.postcode',
      'getUserInput.gender',
      'getUserInput.birthdate',
      'getUserInput.hasPartner',
      'getUserInput.partnerBirthdate',
      'getUserInput.partnerGender',
      'getUserInput.childBirthdate1',
      'getUserInput.childBirthdate2',
      'getUserInput.childBirthdate3',
      'getUserInput.childBirthdate4',
      'getUserInput.childBirthdate5',
      'getUserInput.birthdateContextFields',
      'getUserInput.childGender1',
      'getUserInput.childGender2',
      'getUserInput.childGender3',
      'getUserInput.childGender4',
      'getUserInput.childGender5',
      // 'getUserInput.optionalemail',
    ],
    viewModeLayout: [
      {
        type: 'Div',
        props: {
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gridGap: 2,
        },
        _children: [
          {
            type: 'Div',
            props: {
              display: ['none', null, 'flex'],
              flexDirection: 'row',
              gridGap: 4,
              flexWrap: 'wrap',
            },
            _children: [
              {
                type: 'UneditablePersonalData',
                props: {
                  isMainPerson: true,
                  fieldNamesToRenderSameRow: [
                    'getUserInput.birthdate',
                    'getUserInput.gender',
                  ],
                  postcodeFieldName: 'getUserInput.postcode',
                },
              },
              {
                type: 'UneditablePersonalData',
                props: {
                  header: {
                    default: 'Partner',
                  },
                  fieldNamesToRenderSameRow: [
                    'getUserInput.partnerBirthdate',
                    'getUserInput.partnerGender',
                  ],
                },
              },
              {
                type: 'UneditablePersonalData',
                props: {
                  header: {
                    singleValue: 'Kind',
                    multipleValue: 'Kinderen',
                  },
                  fieldNames: [
                    'getUserInput.childBirthdate1',
                    'getUserInput.childBirthdate2',
                    'getUserInput.childBirthdate3',
                    'getUserInput.childBirthdate4',
                    'getUserInput.childBirthdate5',
                  ],
                  genderFieldNames: [
                    'getUserInput.childGender1',
                    'getUserInput.childGender2',
                    'getUserInput.childGender3',
                    'getUserInput.childGender4',
                    'getUserInput.childGender5',
                  ],
                },
              },
            ],
          },
          {
            type: 'SliderControl',
            props: {
              goto: 1,
              variant: 'personalDataEditIcon',
              children: getRendererFromDescriptor({
                type: 'IconV2',
                props: {
                  name: 'pencil',
                  size: 24,
                },
              }),
            },
          },
        ],
      },
    ],
    formLayout: [
      {
        type: 'PostcodeFieldWrapper',
        props: {
          isStartWidget: true,
          _label: 'Postcode',
          _tooltip:
            'Je postcode kan invloed hebben op het aantal beschikbare zorgverleners',
          _containerProps: {
            mb: 6,
          },
          placeholder: '1234AB',
        },
      },
      {
        type: 'FormInput',
        props: {
          name: 'birthdate',
          component: {
            type: 'Inputs.DateInput',
            props: {
              fieldName: 'getUserInput.birthdate',
              _label: 'Geboortedatum',
              _tooltip:
                'We vragen je geboortedatum, omdat bij sommige zorgverzekeraars leeftijd een rol kan spelen in de premieberekening.',
              _containerProps: {
                display: 'flex',
                mb: 4,
              },
              placeholder: 'dd-mm-jjjj',
              iconPosition: 'right',
              inputMode: 'numeric',
            },
          },
        },
      },
      {
        type: 'TileRadioGroup',
        props: {
          _label: 'Geslacht',
          name: 'gender',
          _fieldName: 'getUserInput.gender',
          direction: 'horizontal',
          style: {
            height: '54px',
            borderRadius: '8px',
          },
          radios: [
            {
              text: 'Man',
              value: 'male',
            },
            {
              text: 'Vrouw',
              value: 'female',
            },
          ],
        },
      },
      {
        type: 'AddPartnerField',
        props: {
          parent: 'form',
          radioGroupProps: {
            _label: 'Geslacht',
            name: 'partnerGender',
            _fieldName: 'getUserInput.partnerGender',
            direction: 'horizontal',
            style: {
              height: '54px',
              borderRadius: '8px',
            },
            radios: [
              {
                text: 'Man',
                value: 'male',
              },
              {
                text: 'Vrouw',
                value: 'female',
              },
            ],
          },
          dateInputProps: {
            placeholder: 'dd-mm-jjjj',
            _label: 'Geboortedatum partner',
            inputMode: 'numeric',
            _containerProps: {},
          },
        },
      },
      {
        type: 'MultipleBirthdateGenderWrapper',
        props: {
          parent: 'form',
          shouldSendCustomEmail: false,
          _label: 'Geboortedatum kind',
          placeholder: 'dd-mm-jjjj',
          iconPosition: 'right',
          inputMode: 'numeric',
          genderFieldProps: {
            _label: 'Geslacht',
            direction: 'horizontal',
            _containerProps: { mt: 3 },
            style: {
              height: '54px',
              borderRadius: '8px',
            },
            radios: [
              {
                text: 'Jongen',
                value: 'male',
              },
              {
                text: 'Meisje',
                value: 'female',
              },
            ],
          },
        },
      },
    ],
    viewModeFooter: [],
  },
};

const filters = [
  {
    type: 'component',
    componentProps: {
      type: 'ToggleVisibleProductsCheckbox',
      props: {
        fieldName: 'overview.showAllProducts',
        _label: 'Toon alle verzekeraars',
      },
    },
  },
  {
    type: 'component',
    sectionSubtitle: 'Aanvullende dekking',
    tooltip:
      'Sommige dekkingen zijn niet standaard meeverzekerd, je kunt je hiervoor apart verzekeren.',
    componentProps: {
      type: 'CoverageFilterWrapper',
      props: {
        numberOfVisibleFilters: 20,
        fieldNames: [
          'getUserInput.birthdate',
          'getUserInput.postcode',
          'getUserInput.gender',
          'getUserInput.partnerBirthdate',
          'getUserInput.partnerGender',
          'overview.filters',
          'overview.dynamicFiltersToListen',
          'getUserInput.coverageadditions',
          'getUserInput.childBirthdate1',
          'getUserInput.childBirthdate2',
          'getUserInput.childBirthdate3',
          'getUserInput.childBirthdate4',
          'getUserInput.childBirthdate5',
          'getUserInput.childGender1',
          'getUserInput.childGender2',
          'getUserInput.childGender3',
          'getUserInput.childGender4',
          'getUserInput.childGender5',
        ],
      },
    },
  },
  {
    type: 'component',
    id: 'deductibleAmount',
    componentProps: {
      type: 'SelectFieldWrapper',
      props: {
        fieldName: 'getUserInput.deductibleAmount',
        _label: 'Eigen risico',
        _labelProps: {
          fontSize: '16px',
          fontWeight: 700,
        },
      },
    },
  },
  {
    title: 'Type basisverzekering',
    id: 'rivm',
    filterById: true,
    fields: [
      {
        fieldId: 'insuranceType-combination-policy',
        label: 'Combinatiepolis',
        value: 'Combinatiepolis',
        optionTooltip:
          'Het hangt van de zorgverlener af of je een vrije keuze hebt. Verder krijg je alleen een volledige vergoeding als het een gecontracteerde zorgverlener is.',
      },
      {
        fieldId: 'insuranceType-naturapolis',
        label: 'Naturapolis',
        value: 'Naturapolis',
        optionTooltip:
          'Hiermee wordt het merendeel van de ziekenhuizen / zorgverleners vergoed. Maak je gebruik van niet-gecontracteerde zorg, dan betaal je een deel van de zorgkosten zelf.',
      },
      {
        fieldId: 'insuranceType-nature-budget',
        label: 'Natura budget',
        value: 'Natura budget',
        optionTooltip:
          'Je bent beperkt in de keuze voor een ziekenhuisvergoeding. Stel je gaat naar een zorgverlener waar zij geen contract mee hebben afgesloten, dan betaal je een deel van de zorgkosten zelf. ',
      },
    ],
    type: 'checkbox',
  },
  // {
  //   type: 'checkbox',
  //   id: 'freeChoiceOfCaregiver',
  //   key: 'coverageBasicHealths.freeChoiceOfCaregiver',
  //   title: 'Keuzevrijheid zorgverleners en ziekenhuizen',
  //   isToggleVisible: true,
  // },
  {
    type: 'component',
    componentProps: {
      type: 'Div',
      _children: [
        {
          type: 'P',
          props: {
            variant: 'baseBodyImportant',
            mb: 1,
            children: 'Wordt jouw zorgverlener vergoed?',
          },
        },
        {
          type: 'P',
          props: {
            variant: 'baseBody',
            m: 0,
            children: 'Wil je een bepaalde zorgverlener 100% vergoed hebben?',
          },
        },
        {
          type: 'CareGiversSearch',
          props: {
            buttonText: 'Voeg jouw zorgverlener toe',
          },
        },
      ],
    },
  },
  {
    type: 'component',
    id: 'showPriceMode',
    sectionSubtitle: 'Premiebetaling per:',
    componentProps: {
      type: 'TileRadioGroupFieldWrapper',
      props: {
        direction: 'horizontal',
        style: {
          height: '48px',
          borderRadius: '8px',
        },
        radios: [
          {
            text: 'Per maand',
            value: 'month',
          },
          {
            text: 'Per jaar',
            value: 'year',
          },
        ],
      },
    },
  },
  {
    title: 'Eigenschappen',
    id: 'strictestLevelNewInsured',
    filterById: true,
    fields: [
      {
        fieldId: 'properties-direct-acceptance',
        label: 'Directe acceptatie',
        value: 'GEEN_SELECTIE_OF_WACHTTIJD',
        optionTooltip:
          'Voor een aanvullende verzekering word je niet altijd direct geaccepteerd. Je moet dan eerst een aantal vragen over je gezondheid of gebit beantwoorden.',
      },
      {
        fieldId: 'properties-no-waiting-time',
        label: 'Geen wachttijd',
        value: 'BEOORDELING',
        optionTooltip:
          'Een wachttijd geldt meestal voor orthodontie of een dure tandartsbehandeling. Je moet dan eerst een jaar de aanvullende verzekering hebben, voordat de rekening van deze behandelingen wordt vergoed.',
      },
    ],
    type: 'checkbox',
  },
  {
    type: 'checkbox',
    id: 'providerName',
    key: 'provider.name',
    title: 'Verzekeraars',
    isToggleVisible: true,
    shortCheckboxesGroupAmount: 3,
  },
];

const overview = {
  name: 'overview',
  components: [
    {
      type: 'OverviewPageNew',
      props: {
        customLoadingPage: {
          contentStyles: {
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
          },
          content: {
            type: 'Div',
            props: {
              width: '300px',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              position: 'relative',
              alignItems: 'center',
            },
            _children: [
              {
                type: 'Div',
                props: {
                  marginBottom: '30%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                },
                _children: [
                  {
                    type: 'Spinner',
                    props: {
                      marginBottom: '24px',
                      width: '48px',
                      height: '48px',
                      color: '#D8D8D8',
                    },
                  },
                  {
                    type: 'Heading',
                    props: {
                      as: 'h4',
                      variant: 'H4',
                      color: '#2B2F3B',
                      fontSize: '24px !important',
                      m: 0,
                      children: 'Een momentje...',
                    },
                  },
                  {
                    type: 'P',
                    props: {
                      mb: '24px',
                      fontSize: '14px !important',
                      variant: 'bodyRegular',
                      color: 'main.5',
                      children:
                        'Wij zoeken nu de beste deals die bij jouw wensen passen.',
                    },
                  },
                  usp('Zorgverzekeraars laden'),
                  usp('Verzekeringen controleren'),
                  usp('Alle premies berekenen'),
                ],
              },
              {
                type: 'Image',
                props: {
                  src: "https://comparators.kizi.nl/assets/logo's/kick.png",
                  position: 'absolute',
                  bottom: 0,
                  height: '30vh',
                  alt: 'overviewLoading',
                },
              },
            ],
          },
        },
        affiliateUrlClientId: 'overstappen',
        filters,
        selectedSorting: 0,
        sortingReference: [
          'totalInstallmentAmount',
          'testScore',
          'sustainabilityScore',
        ],
        dynamicField: 'getUserInput.coverageadditions',
        sortingDescendingOptions: [false, true, true],
        selectedFilters: {
          showPriceMode: ['month'],
          rivm: [],
          Tandheelkundige_hulp_vanaf_18_jaar: ['-1'],
          Fysiotherapie: ['-1'],
          Zwangerschap_en_bevalling: ['-1'],
          Brillen_en_lenzen: ['-1'],
          Hulp_in_het_buitenland: ['-1'],
          Alternatieve_geneeswijzen: ['-1'],
          Anticonceptie: ['-1'],
          freeChoiceOfCaregiver: [],
          strictestLevelNewInsured: [],
          providerName: [],
        },
        sortType: 'overview.showAllProducts',
        sortingOptions: [
          {
            label: 'Laagste prijs',
            icon: 'money',
            value: 0,
          },
          {
            label: 'Beoordeling polisvoorwaarden',
            icon: 'money',
            value: 1,
          },
          {
            label: 'Duurzaamheid ',
            icon: 'money',
            value: 2,
          },
        ],
        bg: 'comparatorBG',
        navPosition: 'left',
        paramsFromFields: [
          'getUserInput.birthdate',
          'getUserInput.hasPartner',
          'getUserInput.postcode',
          'getUserInput.gender',
          'getUserInput.partnerBirthdate',
          'getUserInput.partnerGender',
          'getUserInput.childBirthdate1',
          'getUserInput.childBirthdate2',
          'getUserInput.childBirthdate3',
          'getUserInput.childBirthdate4',
          'getUserInput.childBirthdate5',
          'getUserInput.childGender1',
          'getUserInput.childGender2',
          'getUserInput.childGender3',
          'getUserInput.childGender4',
          'getUserInput.childGender5',
          'getUserInput.coverageadditions',
          'getUserInput.deductibleAmount',
          'overview.careGivers',
          'getUserInput.isStudent',
          'getUserInput.clientName',
        ],
        productsRequest: {},
        defaultQueryParams: { ...defaultCalculateParameters, type: 'health' },
        registerAnalyticsViewListEvent,
        header: [
          {
            type: 'PageHeader',
            props: {
              faq: {
                buttonLabel: 'Veelgestelde vragen',
                buttonIcon: 'comment',
                title: 'Veelgestelde vragen',
                items: faqItems,
                hideLabelOnMobile: true,
              },
              activeStep: 1,
            },
          },
        ],
        withTopThree: true,
        promoSection: [
          {
            type: 'TopThreeSectionWrapper',
            props: {
              mb: 6,
              label: 'Jouw persoonlijke Top 3',
              compareAllThree: true,
            },
            _children: [
              {
                type: 'TopThreeProductsWrapper',
                props: {
                  wrapperStyles: {
                    'div': {
                      boxSizing: 'content-box',
                    },
                  },
                  hidePriceSymbol: true,
                  filters: 'overview.filters',
                  customTopThreeCard: 'TopThreeProductCardHealth',
                  swiperThresholdValues: [0, 85, 153],
                  defaultFilters: 'overview.defaultFilters',
                  multiCompare: true,
                  nextIndex: 4,
                  registerAnalyticsAddToCartEvent,
                  promotionBarModals: {
                    items: [
                      {
                        modal: {
                          contentType: 'incentive',
                          title: 'Unieke Tandongevallen-verzekering',
                          buttonSubtitle:
                            'Dekking tot € 25.000, voor € 0,25 per maand',
                          buttonIcon: 'tooth',
                          buttonIconProps: {
                            width: 18,
                            height: 18,
                            minWidth: 'unset',
                            marginRight: [
                              '5px !important',
                              '5px !important',
                              '10px !important',
                              '10px !important',
                            ],
                          },
                          content: [
                            {
                              type: 'BolContent',
                            },
                          ],
                        },
                      },
                    ],
                    containerStyles: {
                      borderRadius: '16px',
                      padding: ['8px 10px', '8px 10px', '8px 16px'],
                      '> div:first-child': {
                        paddingLeft: 0,
                      },
                    },
                  },
                },
              },
            ],
          },
        ],
        sideNav: [
          personalData,
          {
            type: 'FiltersWrapper',
            props: {
              fields: ['overview.filters', 'overview.defaultFilters'],
            },
          },
          {
            type: 'PartnerContentManager',
            props: {
              descriptor: {
                type: 'Usp',
                props: {
                  css: {
                    padding: '0',
                    bg: 'transparent',
                    boxShadow: 'none',
                    svg: {
                      margin: 0,
                    },
                    div: {
                      gap: '4px',
                      marginBottom: '4px !important',
                      alignItems: 'center',
                      '>p': {
                        color: 'main.2',
                      },
                    },
                  },
                  display: ['none', null, 'block'],
                  marginTop: 6,
                  marginBottom: 6,
                  items: [
                    'Met gratis opzegservice',
                    '14 dagen bedenktijd',
                    'Binnen 2 minuten geregeld',
                  ],
                  iconVerticalAlignment: 'start',
                },
              },
            },
          },
        ],
        content: [
          {
            type: 'Div',
            props: {
              mb: 4,
              mt: [4, 4, null],
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            },
            _children: [
              {
                type: 'Div',
                props: {
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gridGap: 2,
                },
                _children: [
                  {
                    type: 'Div',
                    props: {
                      display: ['none', null, 'initial'],
                    },
                    _children: [
                      {
                        type: 'ModalWithAccordion',
                        props: {
                          buttonLabel: 'Hoe vergelijken wij?',
                          buttonIcon: 'checked-doc',
                          items: howWeCompareItems,
                          title: 'Hoe vergelijken wij?',
                        },
                      },
                    ],
                  },
                  {
                    type: 'PartnerContentManager',
                    props: {
                      descriptor: {
                        type: 'Div',
                        props: {
                          display: ['none', null, 'initial'],
                        },
                        _children: [mailMeThisOverview('Mail mij deze deals')],
                      },
                    },
                  },
                ],
              },
              {
                type: 'FiltersSortingWrapper',
                props: {
                  width: ['100%', '100%', 'initial'],
                  title: 'Sorteren op:',
                  showIcon: true,
                  filtersNameField: 'overview.filters',
                },
              },
            ],
          },
          {
            type: 'ProductsNewWrapper',
            props: {
              filters: 'overview.filters',
              customProductContent: 'ProductCardHealth',
              tabsContent: [
                {
                  label: 'Kenmerken & Premie',
                  content: {
                    type: 'PremiumPolicyTab',
                  },
                },
                {
                  label: 'Vergoedingen',
                  content: {
                    type: 'FeesTabHealth',
                  },
                },
                {
                  label: 'Zorgverleners',
                  content: {
                    type: 'CareGiversTab',
                  },
                },
                {
                  label: 'Beoordelingen',
                  content: {
                    type: 'HealthReviewsTab',
                  },
                },
                {
                  label: 'Extra diensten',
                  content: {
                    type: 'ExtraServicesTab',
                  },
                },
              ],
              defaultFilters: 'overview.defaultFilters',
              disableLoadingSkeleton: false,
              multiCompare: true,
              nextIndex: 4,
              registerAnalyticsAddToCartEvent,
              registerAnalyticsViewItemEvent,
              registerInPeregrineEvent: getStep3DataEvent,
              checkoutInPeregrineEvent: getCheckoutEvent,
              promotionBarModals: {
                items: [
                  {
                    modal: {
                      contentType: 'incentive',
                      title: 'Unieke Tandongevallen-verzekering',
                      buttonIcon: 'tooth',
                      buttonIconProps: {
                        width: 18,
                        height: 18,
                        minWidth: 'unset',
                      },
                      content: [
                        {
                          type: 'BolContent',
                        },
                      ],
                    },
                  },
                ],
              },
            },
          },
          {
            type: 'Div',
            props: {
              height: [20, 35, 50],
              width: '100%',
            },
          },
          { ...uspMobile },
          {
            type: 'AFMBanner',
          },
        ],
        affiliatePageDescriptor: {
          type: 'AffiliateUrlModalWrapper',
        },
      },
    },
  ],
};

export default overview;
